import { addAdvertisingParameters, getAdvertisingParameters } from './advertisingAttribution.js';
import { CONSENT_CHANGED } from './analyticsConsent.js';

const decorateLinks = (browser) => {
  const { document } = browser;
  const parameters = getAdvertisingParameters(browser);
  if (!Object.keys(parameters).length) return () => {};
  const originals = new Map();
  const updateLink = (link) => {
    const href = link.getAttribute('href');
    const updated = addAdvertisingParameters(href, parameters, document.baseURI);
    if (updated !== href) {
      originals.set(link, { original: href, decorated: updated });
      link.setAttribute('href', updated);
    }
  };
  const updateTree = (root) => {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  };
  updateTree(document);

  // Also cover CMS widgets and links created after initial rendering.
  const observer = new browser.MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') updateTree(record.target);
      else record.addedNodes.forEach(updateTree);
    });
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });

  const onClick = (event) => {
    const link = event.target.closest?.('a[href]');
    if (link) updateLink(link);
  };
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  return () => {
    observer.disconnect();
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('auxclick', onClick, true);
    // При отказе убираем только добавленные нами метки, сохраняя параметры автора ссылки.
    originals.forEach(({ original, decorated }, link) => {
      if (link.getAttribute('href') === decorated) link.setAttribute('href', original);
    });
  };
};

const processLinks = (browser = window) => {
  let stop = () => {};
  const refresh = () => {
    stop();
    stop = decorateLinks(browser);
  };
  refresh();
  browser.addEventListener?.(CONSENT_CHANGED, refresh);
  return () => {
    browser.removeEventListener?.(CONSENT_CHANGED, refresh);
    stop();
  };
};

export default processLinks;
